import React from "react";
type Props={
    item:any
}
const PaymentCard=(props:Props)=>{
    const {item}=props;

    return  <div className="bills-card  mb-2 p-5  bg-gray-50 border-gray-100 border-2 rounded-xl">
        <div className="grid grid-cols-1      md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 w-full gap-4 ">
            <div className="w-full mb-3 flex justify-start items-center">
                <strong className="whitespace-nowrap text-xs">مبلغ :  </strong>
                <span className="whitespace-nowrap text-xs mr-2">{item.amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}ریال</span>
            </div>
            <div className="w-full mb-3 flex justify-start items-center">
                <strong className="whitespace-nowrap text-xs">بانک :  </strong>
                <span className="whitespace-nowrap text-xs mr-2">{item.bank}</span>
            </div>
            <div className="w-full mb-3 flex justify-start items-center">
                <strong className="whitespace-nowrap text-xs">تاریخ پرداخت  :  </strong>
                <span className="whitespace-nowrap text-xs mr-2">{item.payment_date}</span>
            </div>
            <div className="w-full mb-3 flex justify-start items-center">
                <strong className="whitespace-nowrap text-xs"> تاریخ تایید :  </strong>
                <span className="whitespace-nowrap text-xs mr-2">{item.approval_date}</span>
            </div>

        </div>


    </div>
}
export default PaymentCard;